import axios from 'axios';

// Create axios instance for student
const studentApi = axios.create({
  //baseURL: 'http://192.168.101.200:8000/api', // same backend API base URL
  //baseURL:'https://testifyrbackend.your-product.in/api',
  baseURL: 'https://examappproductb01.your-product.in/api',   //producation server
});

// Add token automatically for student
studentApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('student_token'); // different key than admin
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

//  Handle expired/unauthorized token
studentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('student_token');
      window.location.href = '/student-login'; // redirect student to login page
    }
    return Promise.reject(error);
  }
);

export default studentApi;
